

let productPriceField = document.getElementById('product_price');
let savingsField = document.getElementById('savings_field');
let quantityField = document.querySelector('.input_for_calc');
let stepSlider = document.getElementById('step_slider');
const radioParents = document.querySelectorAll('.js.product-form__input');
let productStepArray = edproductStepArray;
let savingsArray = edsavingsArray;
let savingsArrayEu = edsavingsArrayEu;
console.log(productCurrency)

let productPrice = productPriceField.textContent;
productPrice = productPrice.replace(',', '.');
productPrice = parseFloat(productPrice)
console.log(productPrice)

if (quantityField) {
    quantityField.addEventListener('change', calcFunc)
    for (const radioParent of radioParents) {
        radioParent.addEventListener('change', function () {
            setTimeout(() => {
                calcFunc();
            }, 1500)
        });
    }
}

function calcFunc() {
    let quantityValue = quantityField.value;

    // Looping over productStepArray and check if quantityValue is greater than or equal to the current value in the array
    for (let i = 0; i < productStepArray.length; i++) {
        if (quantityValue >= productStepArray[i]) {
            if (productCurrency == '€') {
                savingsField.innerText = window.productStrings.yourSaving + ' ' + savingsArrayEu[i] + '%';
                var num = savingsArrayEu[i];
            } else {
                savingsField.innerText = window.productStrings.yourSaving + ' ' + savingsArray[i] + '%';
                var num = savingsArray[i];
            }
            stepSlider.value = 1 + i;

        } else if (quantityValue < productStepArray[0]) {
            savingsField.innerText = '';
            stepSlider.value = 0;
        }
    }

    let totalPrice = productPrice * quantityValue;

    if (num) {
        totalPrice = totalPrice - num
        productPriceField.innerText = totalPrice.toFixed(2) + ' ' + productCurrency;
    } else {
        productPriceField.innerText = totalPrice.toFixed(2) + ' ' + productCurrency;
    }
}